module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_Geländegängig.2d412f03.svg";